import { SECOND } from 'core/common/constants';
import { useTimedSequence } from 'core/common/hooks';
import { exitDurationMs } from 'core/common/ui/ui-kit/motion';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { WrapperStyled, TextStyled } from './styled';

type AnimatedTextProps = {
  list: Array<{
    title?: string;
    text?: string;
  }>;
  totalDurationInSeconds: number;
  className?: string;
};

export const AnimatedText = ({ list, totalDurationInSeconds, className }: AnimatedTextProps) => {
  const itemDurationMs = (totalDurationInSeconds * SECOND) / list.length;

  const { currentIndex, leavingIndex } = useTimedSequence({
    itemsCount: list.length,
    getItemDurationMs: () => itemDurationMs,
    exitDurationMs,
  });

  if (list.length === 0) return null;

  const isVisible = leavingIndex === null;
  const { title, text } = list[leavingIndex ?? currentIndex];

  return (
    <WrapperStyled className={className}>
      <TextStyled
        variant="text-heading-2xl"
        $isVisible={isVisible}
        dangerouslySetInnerHTML={prepareHtml(title)}
      />
      {text && (
        <TextStyled
          mt={1}
          variant="text-body-xs"
          $isVisible={isVisible}
          dangerouslySetInnerHTML={prepareHtml(text)}
        />
      )}
    </WrapperStyled>
  );
};
